import React, { FC, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import {
    Avatar,
    Card,
    CardContent,
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Divider,
} from '@mui/material';
import { CustomerCommand } from '../../../../services/command';
import { NoResultFoundComponent } from '../NoResultFoundComponent/NoResultFoundComponent';
import { SCUILoadingLinear } from '../../../../atomic/atoms';
import { CB2 } from './customerBasketInfosV2.classes';

const tableRowSx = { boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.1)' } as const;
const tableCellSx = { borderBottom: '1px solid rgba(0, 0, 0, 0.1)' } as const;
const productNameCellSx = { maxWidth: '200px', wordWrap: 'break-word' } as const;
const priceCellSx = { minWidth: '100px', wordWrap: 'break-word' } as const;
const cardSx = {
    borderRadius: '15px',
    boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'fit-content',
} as const;
const boldSx = { fontWeight: 'bold' } as const;
const italicSx = { fontStyle: 'italic' } as const;
const minWidth100Sx = { minWidth: '100px' } as const;
const defaultCurrency: any =
    JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.supportedCurrencies?.[0]?.shortCode || '';
export const CustomerBasketInfosV2: FC<any> = ({ datas }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const [photoClickType, setPhotoClickType] = useState('normal');
    const [loading, setLoading] = React.useState(false);
    const [shoppingCartList, setShoppingCartList] = useState<any>();
    useEffect(() => {
        if (datas?.customer?.customerId || searchParams.get('customerId') || searchParams.get('CustomerId')) {
            fetchCustomerBasketInfo();
        }
    }, [datas]);
    const fetchCustomerBasketInfo = () => {
        setLoading(true);
        const customerId = !datas?.customer
            ? Number(searchParams.get('customerId')) || Number(searchParams.get('CustomerId'))
            : datas.customer.customerId;

        if (!customerId) {
            setLoading(false);
            return;
        }

        const reqObject = {
            culture: JSON.parse(localStorage.getItem('languageObject') || '{}').languageCode,
            regionId: JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId,
            warehouseGroupId: JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.warehouseGroupId,
        };

        const request = {
            Context: {
                ApplicationId: 1,
                Culture: reqObject.culture.toString(),
                RegionId: reqObject.regionId,
                WarehouseGroupId: reqObject.warehouseGroupId,
                Platform: 'WEBUI',
            },
            PaymentContext: {
                Key: 'default',
            },
            CustomerId: customerId,
            DontCalcInstallments: true,
            IsCartPage: true,
        };

        CustomerCommand.GetShoppingCarts(request)
            .then((res: any) => {
                setShoppingCartList(res.data.shoppingCartList['1-Installment']);
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const handleClick = () => {
        setPhotoClickType(photoClickType === 'normal' ? 'action' : 'normal');
    };
    return (
        <Grid container spacing={3} alignItems="flex-start" className={CB2.page}>
            {shoppingCartList ? (
                <>
                    {/* Table — left column */}
                    <Grid
                        className={CB2.basketsColumn}
                        size={{
                            xs: 10,
                            md: 10,
                            lg: 10,
                            xl: 10,
                        }}
                    >
                        <Paper
                            className={CB2.basketsPaper}
                            style={{
                                width: '100%',
                                height: '100%',
                                padding: 1,
                                backgroundColor: 'transparent',
                            }}
                        >
                            {shoppingCartList &&
                                shoppingCartList.items.map((item: any, index: any) => (
                                    <TableContainer
                                        className={CB2.basketTable}
                                        component={Paper}
                                        key={index}
                                        style={{
                                            borderRadius: '15px',
                                            marginBottom: '20px',
                                            border: '1px solid rgba(0, 0, 0, 0.1)',
                                            marginTop: index === 0 ? '1rem' : '1rem',
                                        }}
                                    >
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    <TableCell>{t('customerInformation.productName')}</TableCell>
                                                    <TableCell>{t('customerInformation.barcode')}</TableCell>
                                                    <TableCell>{t('customerInformation.color')}</TableCell>
                                                    <TableCell>{t('customerInformation.brand')}</TableCell>
                                                    <TableCell>{t('general.size')}</TableCell>

                                                    <TableCell align="right">
                                                        {t('customerInformation.quantity')}
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        {t('customerInformation.price')}
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <TableRow sx={tableRowSx}>
                                                    <TableCell>
                                                        <Avatar
                                                            className={CB2.inputAvatarProduct}
                                                            sx={{
                                                                width: 80,
                                                                height: 90,
                                                                display: 'inline-block',
                                                                verticalAlign: 'top',
                                                                '& img': {
                                                                    objectFit: 'contain',
                                                                },
                                                            }}
                                                            variant="square"
                                                            src={item.model.options[0].otherIconImage}
                                                            onClick={handleClick}
                                                        />
                                                    </TableCell>

                                                    <TableCell sx={{ ...tableCellSx, ...productNameCellSx }}>
                                                        {item.model.modelTitle}
                                                    </TableCell>
                                                    <TableCell sx={tableCellSx}>{item.model.barcode}</TableCell>
                                                    <TableCell sx={tableCellSx}>
                                                        {item.model.options[0].mainColorName +
                                                            ' ' +
                                                            item.model.colorSpecialCode}
                                                    </TableCell>
                                                    <TableCell sx={tableCellSx}>{item.model.brand}</TableCell>
                                                    <TableCell sx={tableCellSx}>{item.model.size}</TableCell>
                                                    <TableCell align="right" sx={tableCellSx}>
                                                        {item.quantity}
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        sx={{ ...tableCellSx, ...priceCellSx, ...minWidth100Sx }}
                                                    >
                                                        {item.showedPrice > item.showedItemDiscountedPriceTotal ? (
                                                            <div style={minWidth100Sx}>
                                                                <p
                                                                    style={{
                                                                        textDecoration: 'line-through',
                                                                        color: 'red',
                                                                    }}
                                                                >
                                                                    {item.showedPriceStr +
                                                                        ' ' +
                                                                        shoppingCartList?.currency?.symbol}
                                                                </p>
                                                                <p>
                                                                    {item.showedItemDiscountedPriceTotalStr +
                                                                        ' ' +
                                                                        shoppingCartList?.currency?.symbol}
                                                                </p>
                                                            </div>
                                                        ) : (
                                                            <p>
                                                                {item.showedPriceStr +
                                                                    ' ' +
                                                                    shoppingCartList?.currency?.symbol}
                                                            </p>
                                                        )}
                                                        {item.boDiscountStr?.length > 0 ? (
                                                            <p style={{ color: 'red' }}>{item.boDiscountStr}</p>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                ))}
                        </Paper>
                    </Grid>

                    {/* Summary card — right column, vertical */}
                    <Grid
                        className={CB2.summaryColumn}
                        size={{
                            xs: 2,
                            md: 2,
                            lg: 2,
                            xl: 2,
                        }}
                        sx={{ paddingTop: '1rem' }}
                    >
                        <Card sx={cardSx} className={CB2.summaryCard}>
                            <CardContent>
                                <Typography variant="h6" sx={boldSx} gutterBottom className={CB2.fieldSummaryTitle}>
                                    {t('customerInformation.orderSummary')}
                                </Typography>
                                <Divider />

                                <Grid container direction="column" sx={{ rowGap: 1.5, marginTop: '0.75rem' }}>
                                    <Grid className={CB2.fieldTotalProductPrice}>
                                        <Typography variant="caption" color="text.secondary">
                                            {t('customerInformation.totalProductPrice')}
                                        </Typography>
                                        <Typography variant="body2" sx={boldSx}>
                                            {shoppingCartList?.shoppingCartSummary?.showedTotalPriceStr || '0'}{' '}
                                            {shoppingCartList?.currency?.symbol || defaultCurrency}
                                        </Typography>
                                    </Grid>

                                    <Divider />

                                    <Grid sx={italicSx} className={CB2.fieldDiscounts}>
                                        <Typography variant="caption" color="text.secondary">
                                            {t('customerInformation.discounts')}
                                        </Typography>
                                        <Typography variant="body2">
                                            {shoppingCartList?.shoppingCartSummary?.showedTotalDiscountStr || '0'}{' '}
                                            {shoppingCartList?.currency?.symbol || defaultCurrency}
                                        </Typography>
                                    </Grid>

                                    <Divider />

                                    <Grid>
                                        <Typography variant="caption" color="text.secondary" sx={boldSx}>
                                            {t('customerInformation.subtotal')}
                                        </Typography>
                                        <Typography variant="body1" sx={boldSx}>
                                            {shoppingCartList?.shoppingCartSummary?.showedTotalDiscountedPriceStr || 0}{' '}
                                            {shoppingCartList?.currency?.symbol || defaultCurrency}
                                        </Typography>
                                    </Grid>

                                    <Divider />

                                    {shoppingCartList?.shoppingCartSummary?.showedShippingPrice != 0 && (
                                        <Grid className={CB2.fieldCargo}>
                                            <Typography variant="caption" color="text.secondary">
                                                {t('customerInformation.cargo')}
                                            </Typography>
                                            <Typography variant="body2">
                                                {shoppingCartList?.shoppingCartSummary?.showedShippingPriceStr || '0'}{' '}
                                                {shoppingCartList?.currency?.symbol || defaultCurrency}
                                            </Typography>
                                        </Grid>
                                    )}
                                    {shoppingCartList?.shoppingCartSummary?.showedShippingPrice == 0 && (
                                        <Grid className={CB2.fieldCargo}>
                                            <Typography variant="caption" color="text.secondary">
                                                {t('customerInformation.cargo')}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                style={{ color: '#aeaeae', fontStyle: 'italic' }}
                                            >
                                                {t('customerInformation.cargoFree')}
                                            </Typography>
                                        </Grid>
                                    )}

                                    <Divider />

                                    <Grid className={CB2.fieldGrandTotal}>
                                        <Typography variant="caption" sx={boldSx}>
                                            {t('customerInformation.total')}
                                        </Typography>
                                        <Typography variant="body1" sx={boldSx}>
                                            {shoppingCartList?.shoppingCartSummary?.showedGrandTotalStr || 0}{' '}
                                            {shoppingCartList?.currency?.symbol || defaultCurrency}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </>
            ) : !loading ? (
                <NoResultFoundComponent errorText={'Sepet Bilgisi Bulunamadı'} />
            ) : (
                <SCUILoadingLinear display={loading} />
            )}
        </Grid>
    );
};
